// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import VehicleFreeze from '@services/vehicle/freeze'

export const getAllVehicleFreezes = createAsyncThunk('freeze/getAllVehicleFreezes', async (params, { rejectWithValue }) => {
  try {
    const response = await VehicleFreeze.getAllVehicleFreezes(params)
    return { 
      params, 
      data: response?.data || [], 
      totalPages: response?.meta?.itemCount || 0 
    }
  } catch (err) {
    return rejectWithValue(err.response?.data || { message: 'Failed to fetch freezes' })
  }
})

export const getVehicleFreeze = createAsyncThunk('freeze/getVehicleFreeze', async (id, { rejectWithValue }) => {
  try {
    const response = await VehicleFreeze.getSingleVehicleFreeze(id)
    return response || {}
  } catch (err) {
    return rejectWithValue(err.response?.data || { message: 'Failed to fetch freeze' })
  }
})

export const addVehicleFreeze = createAsyncThunk('freeze/addVehicleFreeze', async (data, { rejectWithValue, dispatch, getState }) => {
  try {
    const response = await VehicleFreeze.createVehicleFreeze(data)
    dispatch(getAllVehicleFreezes(getState()?.vehicleFreezes?.params || {}))
    return response || {}
  } catch (err) {
    return rejectWithValue(err.response?.data || { message: 'Failed to create freeze' })
  }
})

export const updateVehicleFreeze = createAsyncThunk('freeze/updateVehicleFreeze', async (data, { rejectWithValue, dispatch, getState }) => {
  try {
    const response = await VehicleFreeze.updateVehicleFreeze(data.id, data.payload)
    dispatch(getAllVehicleFreezes(getState()?.vehicleFreezes?.params || {}))
    return response || {}
  } catch (err) {
    return rejectWithValue(err.response?.data || { message: 'Failed to update freeze' })
  }
})

export const deleteVehicleFreeze = createAsyncThunk('freeze/deleteVehicleFreeze', async (id, { rejectWithValue, dispatch, getState }) => {
  try {
    const response = await VehicleFreeze.deleteVehicleFreeze(id)
    dispatch(getAllVehicleFreezes(getState()?.vehicleFreezes?.params || {}))
    return response || {}
  } catch (err) {
    return rejectWithValue(err.response?.data || { message: 'Failed to delete freeze' })
  }
})


const vehicleFreezesSlice = createSlice({
  name: 'vehicleFreezes',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedFreeze: null
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getAllVehicleFreezes.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.selectedFreeze = null
      })
      .addCase(getVehicleFreeze.fulfilled, (state, action) => {
        state.selectedFreeze = action.payload
      })
      .addCase(updateVehicleFreeze.fulfilled, (state, action) => {
        if (!action.payload?.id) {
          return
        }
        const { id } = action.payload
        const freezes = state.data.filter((freeze) => freeze.id !== id)
        state.data = [...freezes, action.payload]
      })
  }
})

export default vehicleFreezesSlice.reducer
